export interface FlightSearchDisplayTextParams {
  originAirportCode: string
  destinationAirportCode: string
  departureDate: string
  returnDate?: string
}

// Shared by both the activity entry (`flight_search_submitted`) and the committed-state entry
// (`last_flight_search`) -- same underlying search, same customer-facing summary, so one composer
// rather than two copies that could silently drift apart.
export function formatFlightSearchDisplayText({
  originAirportCode,
  destinationAirportCode,
  departureDate,
  returnDate,
}: FlightSearchDisplayTextParams): string {
  const returnSuffix = returnDate ? `, returning ${returnDate}` : ''
  return `Searched flights from ${originAirportCode} to ${destinationAirportCode}, departing ${departureDate}${returnSuffix}`
}
